import React from 'react'
import * as facemesh from '@tensorflow-models/facemesh'
import {BsChevronLeft} from 'react-icons/bs'
import model1 from '../images/model1.jpg'
import model2 from '../images/model2.jpg'
import model3 from '../images/model3.jpg'
import model4 from '../images/model4.jpg'
import model5 from '../images/model5.jpg'
import model6 from '../images/model6.jpg'
import Loader from './loader'
import {sequence} from './sequence'
import color from './colors'
export default class Model extends React.Component{
	constructor(props){
		super(props)
		this.state={
			selected:false,
			selectedImage:'model',
			loading:false,
			selectedColor:'None'
		}
		this.canvasRef=React.createRef()
		this.imageRef1=React.createRef()
		this.imageRef2=React.createRef()
		this.imageRef3=React.createRef()
		this.imageRef4=React.createRef()
		this.imageRef5=React.createRef()
		this.imageRef6=React.createRef()
		this.loadModal=this.loadModal.bind(this)
		this.renderCanvas=this.renderCanvas.bind(this)
		this.backBtnClick=this.backBtnClick.bind(this)
		this.selectImage=this.selectImage.bind(this)
		this.changeColor=this.changeColor.bind(this)
		if(window.innerWidth>760){
			this.canvasHeight=500
			this.canvasWidth=500
		} 
		else{
			this.canvasWidth=window.innerWidth
			this.canvasHeight=window.innerWidth
		}
		this.colors=color
	}
	selectImage(val){
		this.ref=val
		this.setState({
			selected:true, 
			loading:true
		})
		this.loadModal()
	}
	changeColor(val){
		this.setState({
			selectedColor:val.rgba
		})
		this.renderCanvas()
	}
	backBtnClick(){
		this.props.close(true)
	}
	loadModal(){
		facemesh.load().then((modal)=>{
			this.modal=modal
			this.renderCanvas()
		})
	}
	renderCanvas(){
		this.setState({loading:false})
		this.canvasRef.current.getContext('2d').drawImage(this.ref.current,0,0,this.canvasWidth,this.canvasHeight)
		this.modal.estimateFaces(this.canvasRef.current)
		.then((val)=>{	
			let sequencePoints=[]
			const ctx=this.canvasRef.current.getContext('2d')
			ctx.strokeStyle='rgba(195, 12, 61, 0.9)'
			ctx.lineWidth=0.1
			const scaledMesh = val[0].scaledMesh
			for(let x in sequence){
					let point=scaledMesh[sequence[x]]
					let arr={
						x:point[0],
						y:point[1]
					}
					sequencePoints.push(arr)
				}
				const region = new Path2D()
				region.moveTo(sequencePoints[0].x,scaledMesh[0].y)
			 	const draw=()=>{
			 	for(let i=1 ; i< sequencePoints.length;i++){
			 		region.lineTo(sequencePoints[i].x,sequencePoints[i].y)
			 	}
			 	region.closePath()
				ctx.stroke(region)
				if(this.state.selectedColor!=='None'){
					ctx.fillStyle = this.state.selectedColor
					ctx.fill(region,'nonzero')
				}
			 	}
		 		draw()
		})
	}
	render(){
		return(
			<div className="tryon-container">
				<button className="back-btn" onClick={this.backBtnClick}><BsChevronLeft/></button>
				{!this.state.selected ? 
				<div className="secondary-tryon-container">
					<div className="model-selector">
						<div className="image-container ">
							<p className="choose-mess-model">Choose a Model </p>
							<img src={model1} ref={this.imageRef1} className="image" alt="model1" onClick={()=>this.selectImage(this.imageRef1)}/>
							<img src={model2} ref={this.imageRef2} className="image" alt="model2" onClick={()=>this.selectImage(this.imageRef2)}/>
							<img src={model4} ref={this.imageRef4} className="image" alt="model4" onClick={()=>this.selectImage(this.imageRef4)}/>
							<img src={model5} ref={this.imageRef5} className="image" alt="model5" onClick={()=>this.selectImage(this.imageRef5)}/>
							<img src={model6} ref={this.imageRef6}className="image" alt="model6" onClick={()=>this.selectImage(this.imageRef6)}/>
						</div>
					</div>
				</div>
				:
				(this.state.loading ? 
					<div className="secondary-tryon-container">
						<Loader/>
					</div>
				:
					<div className="secondary-tryon-container">
						<img src={model1} ref={this.imageRef1} className="image-hide" alt="model1"/>
						<img src={model2} ref={this.imageRef2} className="image-hide" alt="model1"/>
						<img src={model3} ref={this.imageRef3} className="image-hide" alt="model1"/>
						<img src={model4} ref={this.imageRef4} className="image-hide" alt="model1"/>
						<img src={model5} ref={this.imageRef5} className="image-hide" alt="model1"/>
						<img src={model6} ref={this.imageRef6} className="image-hide" alt="model1"/>
						<canvas className="text-center" ref={this.canvasRef} height={this.canvasHeight} width={this.canvasWidth}></canvas>
						<div className="slider">
							{this.state.selectedColor==='None' ? <p className="choose-mess">Choose a Shade!!</p> : <p className="choose-mess"></p>}
							{this.colors.map((val)=><button className="scroll-div" style={{backgroundColor:val.hex}} key={val.name} onClick={()=>this.changeColor(val)}>{val.name}</button>)}
							
						</div>
					</div>
				)}
			</div>
		)
	}
}